//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    font-size: 14px;
`;